import React from 'react';
import { CommandeBCI, TabDescriptor } from '../types';
import CommandeOffre from './CommandeOffre';

interface CommandeContentProps {
  commande: CommandeBCI;
  activeTab: TabDescriptor | null;
  // Rafraichit la commande apres l'envoi de l'offre (remplace window.location.reload()).
  refetch: () => Promise<void> | void;
}

// Presta BCI : un seul onglet "Offre". Routeur trivial par `kind` (jamais par index).
const CommandeContent: React.FC<CommandeContentProps> = ({ commande, activeTab, refetch }) => {
  if (!activeTab || activeTab.kind !== 'offre') return null;
  return <CommandeOffre commande={commande} refetch={refetch} />;
};

export default CommandeContent;
